module.exports = __webpack_public_path__ + "img/lt.68f88c5c.png";